import React from "react";
import { Alert, AlertDescription } from "../components/ui/alert";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Progress } from "../components/ui/progress";

import { useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";

export default function DndShowcase() {
    const { resources } = useModelIndex("analytics_event" as any, { limit: 1 } as any);
    const steps = ["Capture signal", "Translate capability", "Assess readiness", "Route to navigator"];
    const [current, setCurrent] = useState(0);
  return (
   <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Card>
      <CardHeader>
      <Badge className="w-fit">DND Team Showcase</Badge>
      <CardTitle>Clickable Dual-Use Intake Demo for DND Teams</CardTitle>
      <CardDescription>Explore the guided workflow and reliability controls in a single walkthrough.</CardDescription>
      <p className="text-sm text-muted-foreground">Full dual-use journey from entry fork to routing recommendation: AI translation, signal triage, readiness guidance, and the distinct value proposition for dual-use companies.</p>

      </CardHeader>
      <CardContent>
      <Button asChild><Link to="/dual-use-on-ramp/intake">Run Guided Scenario</Link></Button>
      </CardContent>
      </Card>
      <Card className="overflow-hidden">
      <img src="https://pixabay.com/get/g776323bbafac6a547513bc0a02df0788d36efda95762f35afe7606e178fa5a08234f9f1e421f523f32fc8e2c2523ff13a62c1c1eb20d9b65860daf40747c321d_640.jpg" alt="Technology showcase" className="h-full min-h-64 w-full object-cover" />
      </Card>
      </section>
  <section className="space-y-4">
      <h2 className="text-xl font-semibold">Scenario Walkthrough</h2>
      <Card>
      <CardContent className="space-y-4 p-4">
      <div className="flex items-center justify-between"><p>{steps[current]}</p><Badge>{current + 1}/{steps.length}</Badge></div>
      <Progress value={((current + 1) / steps.length) * 100} />
      <div className="flex gap-2">
      <Button variant="outline" onClick={() => setCurrent((value) => Math.max(0, value - 1))}>Previous</Button>
      <Button onClick={() => setCurrent((value) => Math.min(steps.length - 1, value + 1))}>Next</Button>
      </div>
      </CardContent>
      </Card>
      </section>
  <section>
      <Card>
      <CardContent className="space-y-3 p-4">
      {[
      "Translation in seconds",
      "Non-blocking UI",
      "Server-proxied model calls",
      ].map((check) => (
      <Alert key={check}><Badge className="mr-2" variant="secondary">Check</Badge><AlertDescription className="inline">{check}</AlertDescription></Alert>
      ))}
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}